// 驼峰转下划线
export const camelToUnderline = (obj) => {
  if (obj instanceof Array) {
    return obj.map(item => camelToUnderline(item))
  } else if (obj instanceof Object && !(obj instanceof String)) {
    const newObj = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        // 只处理键名，不处理属性值
        const newKey = key.replace(/(?!^)([A-Z])/g, '_$1').toLowerCase()
        // 对属性值递归处理，但字符串类型直接返回原值
        const value = obj[key]
        if (value instanceof Array || (value instanceof Object && !(value instanceof String))) {
          newObj[newKey] = camelToUnderline(value)
        } else {
          newObj[newKey] = value
        }
      }
    }
    return newObj
  }
  // 字符串类型直接返回原值，不做处理
  return obj
}

// 下划线转驼峰
export const underlineToCamel = (obj) => {
  if (typeof obj === 'string') {
    return obj.replace(/_(\w)/g, (_, c) => c.toUpperCase())
  } else if (obj instanceof Array) {
    return obj.map(item => underlineToCamel(item))
  } else if (obj instanceof Object) {
    const newObj = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const newKey = key.replace(/_(\w)/g, (_, c) => c.toUpperCase())
        newObj[newKey] = underlineToCamel(obj[key])
      }
    }
    return newObj
  }
  return obj
}

// 金额格式化（保留两位小数）
export const formatMoney = (num) => {
  if (typeof num !== 'number') num = Number(num)
  return num.toFixed(2)
}

// 金额格式化（带货币符号）
export const formatAmount = (amount) => {
  if (!amount) return '¥0.00'
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  return `¥${(num / 100).toFixed(2)}`
}

// 积分格式化（添加千分位）
export const formatPoints = (num) => {
  if (typeof num !== 'number') num = Number(num)
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 手机号格式化（中间四位隐藏）
export const formatPhone = (phone) => {
  if (!phone) return ''
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

// 身份证号格式化（中间8位隐藏）
export const formatIdCard = (idCard) => {
  if (!idCard) return ''
  return idCard.replace(/(\d{6})\d{8}(\d{4})/, '$1********$2')
}

// 时间格式化
export const formatTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return ''
  
  const d = new Date(date)
  if (isNaN(d.getTime())) return ''
  
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

// 相对时间格式化（刚刚、X分钟前、X小时前、X天前、超过7天显示日期）
export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return ''
  const now = Math.floor(Date.now() / 1000)
  const diff = now - timestamp
  if (diff < 60) return '刚刚'
  if (diff < 3600) return `${Math.floor(diff / 60)}分钟前`
  if (diff < 86400) return `${Math.floor(diff / 3600)}小时前`
  if (diff < 604800) return `${Math.floor(diff / 86400)}天前`
  const date = new Date(timestamp * 1000)
  return `${date.getMonth() + 1}-${date.getDate()}`
}

// 生成订单号
export const generateOrderNo = () => {
  const timestamp = Date.now()
  const random = Math.floor(Math.random() * 10000)
  return `ORD${timestamp}${random.toString().padStart(4, '0')}`
}
